import React, { Component } from 'react'
import TopBar from '../../components/TopBar'
import Modal from '../../components/Modal'
import './Overview.css'
import '../styles.css'
import api from '../../api'
import moment from 'moment'


/* Titles */
/* End of Titles */

/* Texts */
/* End of Texts */

/* Images */
/* End of Images */

const DUK1 = 'duk1'
const DUK2 = 'duk2'
const DUK_PRIS = 245
const moneyFormat = (number) => {
  let [numberAsString, trailing] = String(number).split('.')
  trailing = trailing / 10 < 1 ? trailing + '0' : trailing
  let res = ''

  for (let i = 0; i < numberAsString.length; i++) {
    if (i % 3 === 0 && i !== 0)
      res = ' ' + res
    res = numberAsString[numberAsString.length - i - 1] + res
  }
  return res + (trailing ? (',' + trailing) : ',00')
}
class Overview extends Component {

  state = {
    orders: [],
    status: 'overview',
    lastOpenedWeek: null,
    visibility: false,
    deleteModal: false,
    searchCriteria: '',
    editingOrder: {},
    activeOrder: {},
    duk1: {},
    duk2: {},
    rabatt: 0,
    mva: 0,
    totalPris: 0,
    sum: 0,
  }

  async componentDidMount() {
    const token = localStorage.token
    if (!token)
      this.props.history.push({ pathname: '/login', search: this.props.history.location.search })
    await this.getOrders()
    require('dotenv').config()
    const API_URL = process.env.REACT_APP_API_URL
    this.setState({ API_URL })
  }

  async getOrders() {
    const token = localStorage.token
    const orders = await api('getAllOrders', { token })

    this.countOrders(orders)
    await this.setState({ orders })
    await this.groupOrdersInWeeks()
  }

  countOrders = (orders) => {
    let duk1 = 0
    let duk2 = 0
    let sum = 0

    for (const order of (orders || [])) {

      const duks = JSON.parse(order.duks)
      console.log("duks", duks)
      duk1 += duks.duk1 ? duks.duk1.number || 0 : 0
      duk2 += duks.duk2 ? duks.duk2.number || 0 : 0
    }

    sum = duk1 + duk2
    const numOrders = orders.length

    // important script dont remove this log
    console.log("numOrders", numOrders,
      "numDuks:", sum,
      "numDuks1:", duk1,
      "numDuks2:", duk2,
    )
  }

  async groupOrdersInWeeks() {
    let weekOrders = {}
    const { orders } = this.state
    if (!orders) {
      return weekOrders
    }
    for (const order of orders) {
      const week = moment(order.date).week()
      const year = moment(order.date).year()
      const key = year + ' ' + week

      let foundWeek = Object.keys(weekOrders).find(element =>
        element === key
      )


      if (foundWeek) {
        const currentWeek = weekOrders[key]
        const ordersArray = currentWeek.slice(0, currentWeek.length - 1)
        ordersArray.push(order)
        if (order.status === 'not_sendt') {
          ordersArray.push('Avventer behandling')
        } else {
          ordersArray.push(currentWeek[currentWeek.length - 1])
        }
        weekOrders[key] = ordersArray
      } else {
        const status = order.status === 'sendt' ?
          'Alle bestillinger er utsendt'
          : 'Avventer behandling'

        weekOrders = {
          ...weekOrders,
          [key]: [order, status]
        }
      }
    }
    await this.setState({ weekOrders })
  }

  updateNumDuks = (dukType) => (event) => {
    const sumEksMva = (event.target.value * DUK_PRIS) + this.state.duk2.price
    this.setState({
      [dukType]: {
        number: event.target.value,
        price: event.target.value * DUK_PRIS,
      },
      sum: sumEksMva
    })
    const minimumRabattPrice = 50 * DUK_PRIS
    const rabatt = sumEksMva >= minimumRabattPrice ?
      (sumEksMva * 10) / 100
      : 0
    const sumEtterRabatt = sumEksMva - rabatt
    const mva = (sumEtterRabatt * 25) / 100
    const totalPris = sumEtterRabatt + mva

    this.setState({
      rabatt,
      mva,
      totalPris
    })
  }

  search = async (event) => {
    await this.setState({ searchCriteria: event.target.value })
    const { searchCriteria } = this.state
    const token = localStorage.token
    const orders = await api('getAllOrders', { token, searchCriteria, })
    await this.setState({ orders })
    await this.groupOrdersInWeeks()
  }

  backToOverview = async () => {
    await this.getOrders()
    await this.setState({
      lastOpenedWeek: this.state.status,
      status: 'overview',
      searchCriteria: '',
    })
  }

  renderOverviewTable = () => {
    let { weekOrders } = this.state
    if (!weekOrders)
      weekOrders = {}
    let weekKeys = !weekOrders ? [] : Object.keys(weekOrders)
    console.log("weekKeys", weekKeys)
    if (weekKeys && weekKeys.length && weekKeys.length > 1)
      weekKeys = weekKeys.sort((a, b) => b - a)

    return (
      <div className="Column">
        <div className="Row Space-between Margin-bottom-50 Overview-flex-container">
          <a
            className="Overview-back-button"
            download
            href={this.state.API_URL + `/dommekraft-bestillinger.xlsx?token=${localStorage.token}`}
            style={{
              lineHeight: '26px',
              textDecoration: 'none',
              textAlign: 'center',
              cursor: 'pointer',
            }}
          >Last ned</a>
          <input
            value={this.state.searchCriteria}
            placeholder="Søk"
            className="Bestill-small-input"
            onChange={this.search}
          />
        </div>

        {


          !weekKeys || !weekKeys.length ? null : weekKeys.map((week, index) => {
            const currentOrders = weekOrders[week]
            const orderStatus = currentOrders[currentOrders.length - 1]
            return (
              <div
                className="Column Pointer"
                key={"order" + index}
                onClick={() => this.setState({ status: week, lastOpenedWeek: null })}
              >
                <div className={this.state.lastOpenedWeek === week ? "Colored-row Visited-week" : "Colored-row"} >
                  <div className="Overview-week-text">
                    Uke {week.split(" ")[1]}, {week.split(" ")[0]} -
                    Bestillinger {currentOrders.length - 1}
                  </div>
                  <div className="Overview-text-1">
                    {orderStatus}
                  </div>
                </div>
              </div>
            )
          }
          )}
      </div>
    )
  }

  renderDuks = (current) => {

    const keys = ['duk1', 'duk2']
    return (
      <div>
        <div className="Overview-text-2">
          <span style={{ fontSize: 18, lineHeight: 1.5 }}>
            Duk
          </span>
        </div>
        <div className="Column">
          <div className="Padding-left-20">
            {keys.map((duk, dukIndex) => (
              <div
                key={"duk " + dukIndex + " "}
                className="Colored-row Color-white"
              >
                <div>
                  <div>
                    <div className="Overview-text-2">
                      <span style={{ fontWeight: 'bold' }}>
                        {duk}:{duk === 'sum' ? <span style={{ paddingLeft: 5 }}>{current[duk]}</span> : null}
                      </span>
                    </div>
                  </div>
                  {duk === 'sum' ? null
                    :
                    <div className="column">
                      <div className="Padding-left-15">
                        <div className="Overview-text-2">
                          <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
                            antall:
                          </span>
                          {current[duk].number}
                          <br />
                          <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
                            pris:
                          </span>
                          {moneyFormat(current[duk].price)} kr
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            )

            )}
          </div>
        </div>
      </div>
    )
  }

  renderOrder = (order) => {
    const orderDetails = JSON.parse(order.duks)
    const duk1Pris = orderDetails.duk1.price || 0
    const duk2Pris = orderDetails.duk2.price || 0
    const sum = duk2Pris + duk1Pris
    return (
      <div>
        <div className="Overview-text-2">
          <span style={{ fontSize: 18, lineHeight: 1.5 }}>
            Bestilling
          </span>
          <div className="Padding-left-15">
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              dato:
            </span>
            {order.date}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              id:
            </span>
            {order.order_id}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              status:
            </span>
            {order.status}
          </div>
        </div>
        <div className="Empty-space-15" />
        <div className="Overview-text-2">
          <span style={{ fontSize: 18, lineHeight: 1.5 }}>
            Kunde
          </span>
          <div className="Padding-left-15">
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              fornavn:
            </span>
            {order.first_name}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              etternavn:
            </span>
            {order.last_name}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              mobilnr:
            </span>
            {order.mobile_number}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              epost:
            </span>
            {order.email}
          </div>
        </div>
        <div className="Empty-space-15" />
        <div className="Overview-text-2">
          <span style={{ fontSize: 18, lineHeight: 1.5 }}>
            Faktura
          </span>
          <div className="Padding-left-15">
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Adresse:
            </span>
            {order.billing_address}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Postnummer:
            </span>
            {order.billing_zipcode}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Poststed:
            </span>
            {order.billing_city}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Kommune:
            </span>
            {order.billing_commune}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Referanse:
            </span>
            {order.reference}
          </div>
        </div>
        <div className="Empty-space-15" />
        <div className="Overview-text-2">
          <span style={{ fontSize: 18, lineHeight: 1.5 }}>
            Levering
          </span>
          <div className="Padding-left-15">
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Adresse:
            </span>
            {order.shipping_address}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Postnummer:
            </span>
            {order.shipping_zipcode}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Poststed:
            </span>
            {order.shipping_city}
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Kommune:
            </span>
            {order.shipping_commune}
            <br />
          </div>
        </div>
        <div className="Empty-space-15" />
        {this.renderDuks(orderDetails)}
        <div className="Empty-space-15" />
        <div className="Overview-text-2">
          <span style={{ fontSize: 18, lineHeight: 1.5 }}>
            Pris
          </span>
          <div className="Padding-left-15">
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Sum eks. mva:
            </span>
            {moneyFormat(sum)} kr
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Rabatt:
            </span>
            - {moneyFormat(orderDetails.rabatt)} kr
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Mva:
            </span>
            {moneyFormat(orderDetails.mva)} kr
            <br />
            <span style={{ fontWeight: 'bold', paddingRight: 5 }}>
              Total pris:
            </span>
            {moneyFormat(orderDetails.totalPris)} kr
          </div>
        </div>

      </div>
    )
  }

  editOrder = async (editingOrder) => {
    await this.setState({ editingOrder })
    let duks = JSON.parse(editingOrder.duks)
    const duk1Pris = duks.duk1.price || 0
    const duk2Pris = duks.duk2.price || 0
    const sum = duk2Pris + duk1Pris
    await this.setState({
      duk1: duks.duk1,
      duk2: duks.duk2,
      sum,
      rabatt: duks.rabatt,
      mva: duks.mva,
      totalPris: duks.totalPris
    })
    this.toggleModal()
  }

  renderControlButtons = (order) => {
    return (
      <div className="Column">
        <button
          className={order.status === 'sendt' ? "Overview-button Gray" : "Overview-button"}
          onClick={() => this.changeOrderStatus(order)}
        >
          {
            order.status === "sendt" ?
              "Marker som ikke utsendt"
              : "Marker som utsendt"
          }
        </button>
        <div className="Empty-space-15" />
        <button
          className="Overview-button"
          onClick={() => this.editOrder(order)}
        >
          Rediger bestilling
        </button>

        <div className="Empty-space-15" />

        <button
          className="Overview-button Color-red"
          onClick={() => this.deleteOrder(order.order_id)}
        >
          Slett bestilling
        </button>
      </div>

    )
  }

  renderWeekOrders = () => {
    let { weekOrders } = this.state
    if (!weekOrders)
      weekOrders = {}
    const currentWeek = weekOrders[this.state.status]
    return (
      <div className="Column">
        <div className="Overview-search-container">
          <button
            className="Overview-back-button"
            onClick={this.backToOverview}
          >
            Returner til oversikt
          </button>
        </div>
        {currentWeek ? currentWeek.map((order, index) => (
          <div className="Column" key={"Inner-orders" + index}>
            {
              index === currentWeek.length - 1 ? null
                :
                <div className="Colored-row">
                  <div className="Column">
                    {this.renderOrder(order)}
                  </div>
                  <div className="Column">
                    {this.renderControlButtons(order)}
                  </div>
                </div>
            }
            <div className="Empty-space-15" />
          </div>
        ))
          :
          <div />
        }
      </div>
    )
  }

  toggleModal = () => {
    this.setState({ visibility: !this.state.visibility })
  }

  saveChanges = async () => {
    const { editingOrder, duk1, duk2, totalPris, rabatt, mva } = this.state
    const token = localStorage.token
    const res = await api('editOrder', { token, order: editingOrder, duk1, duk2, rabatt, totalPris, mva })
    if (res === true) {
      await this.getOrders()
    }
    this.toggleModal()
  }

  changeOrderStatus = async (order) => {
    const token = localStorage.token
    const res = await api('changeOrderStatus', { orderId: order.order_id, token, status: order.status })
    if (res === true) {
      await this.getOrders()
    }
  }

  deleteOrder = async (orderId) => {
    await this.setState({ activeOrder: orderId })
    this.toggleDeleteModal()
  }

  confirmDelete = async () => {
    this.toggleDeleteModal()
    const { activeOrder } = this.state
    const token = localStorage.token
    const res = await api('deleteOrder', { orderId: activeOrder, token })
    if (res === true) {
      await this.getOrders()
    }

  }

  render() {
    return (
      <div className="OuterContainer">
        <div style={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
          <TopBar activePage={'Min side'} />
          <div className="Column">
            <div className="Overview-outer-container Disable-padding Column-center-aligned Center-aligned">
              <div className="Overview-container">
                {this.state.status === 'overview' ?
                  this.renderOverviewTable()
                  :
                  this.renderWeekOrders()
                }
              </div>
            </div>
          </div>
          {this.renderModal()}
          {this.deleteModal()}
        </div>
      </div>
    )
  }

  toggleDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal })
  }

  deleteModal = () => {
    return (
      <Modal
        display={this.state.deleteModal}
        hide={() => { }}
      >
        <div className="Overview-modal-container">
          <div className="Overview-text-2">
            Er du sikker på at du vil slette denne bestillingen?
          </div>
          <div className="Row Center-aligned Center-content">
            <button
              className="Overview-cancel Width-100 Margin-10"
              onClick={this.confirmDelete}
            >
              Ja
            </button>
            <button
              className="Overview-cancel Gray Width-100 Margin-10"
              onClick={this.toggleDeleteModal}
            >
              Nei
            </button>
          </div>
        </div>
      </Modal>
    )

  }

  renderModal = () => {
    let { editingOrder } = this.state
    return (
      <Modal
        display={this.state.visibility}
        hide={() => { }}
      >
        <div className="Overview-modal-container" style={{ paddingLeft: 50, paddingRight: 50 }}>
          <div className="Overview-text-2">
            <div className="Row Space-between">
              Bestilling  {editingOrder.order_id}
            </div>
            <div className="Empty-space-15" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Fornavn:
              </span>
              <input
                value={this.state.editingOrder.first_name}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      first_name: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Etternavn:
              </span>
              <input
                value={this.state.editingOrder.last_name}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      last_name: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Mobilnr:
              </span>
              <input
                value={this.state.editingOrder.mobile_number}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      mobile_number: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Epost:
              </span>
              <input
                value={this.state.editingOrder.email}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      email: event.target.value
                    }
                  })
                )}
              />
            </div>

            <div className="Empty-space-15" />
            <div className="Row Space-between">
              Faktura
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Adrresse:
              </span>
              <input
                value={this.state.editingOrder.billing_address}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      billing_address: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Postnummer:
              </span>
              <input
                value={this.state.editingOrder.billing_zipcode}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      billing_zipcode: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Poststed:
              </span>
              <input
                value={this.state.editingOrder.billing_city}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      billing_city: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Empty-space-15" />
            <div className="Row Space-between">
              Levering
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Adrresse:
              </span>
              <input
                value={this.state.editingOrder.shipping_address}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      shipping_address: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Postnummer:
              </span>
              <input
                value={this.state.editingOrder.shipping_zipcode}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      shipping_zipcode: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Poststed:
              </span>
              <input
                value={this.state.editingOrder.shipping_city}
                className="Bestill-small-input"
                onChange={(event) => (
                  this.setState({
                    editingOrder: {
                      ...editingOrder,
                      shipping_city: event.target.value
                    }
                  })
                )}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Empty-space-15" />
            <div className="Row Space-between">
              Duks
            </div>
            <div className="Empty-space-5" />
            <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
              duk1:
            </span>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Antall:
              </span>
              <input
                value={this.state.duk1.number}
                className="Bestill-small-input"
                type="number"
                onChange={this.updateNumDuks(DUK1)}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Pris: {this.state.duk1.price}
              </span>
            </div>
            <div className="Empty-space-15" />
            <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
              duk2:
            </span>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Antall:
              </span>
              <input
                value={this.state.duk2.number}
                className="Bestill-small-input"
                type="number"
                onChange={this.updateNumDuks(DUK2)}
              />
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Pris: {this.state.duk2.price}
              </span>
            </div>
            <div className="Empty-space-5" />
            <div className="Empty-space-5" />
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Sum eks. mva: {moneyFormat(this.state.sum)} kr
              </span>
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Rabatt: - {moneyFormat(this.state.rabatt)} kr
              </span>
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Mva: {moneyFormat(this.state.mva)} kr
              </span>
            </div>
            <div className="Empty-space-5" />
            <div className="Row Space-between Center-aligned">
              <span style={{ fontWeight: 'bold', paddingRight: 5, paddingBottom: 10 }}>
                Total pris: {moneyFormat(this.state.totalPris)} kr
              </span>
            </div>
          </div>
          <div className="Row Center-aligned Center-content">
            <button
              className="Overview-save"
              onClick={this.saveChanges}
            >
              Lagre endringer
            </button>
            <button
              className="Overview-cancel"
              onClick={this.toggleModal}
            >
              Lukk uten lagring
            </button>
          </div>
        </div>
      </Modal>

    )
  }


}


export default Overview 



// WEBPACK FOOTER //
// ./src/pages/Overview/index.js